import { api } from './client'

/**
 * F-161 (TASK-0415): client di `UserDirectoryController` (`GET /api/user-directory`). Elenco minimo degli utenti per il
 * personale (Admin, direzione, area manager, backoffice): solo id, nome, ruolo, stato e responsabile. L'area manager
 * vede solo se stesso e i subordinati; Agent, Operator e Commercialista ricevono 403.
 */
export interface DirectoryUser {
  id: number
  name: string
  role: string
  isActive: boolean
  parentUserId: number | null
}

export interface UserDirectoryQuery {
  search?: string
  roles?: string[]
  ids?: number[]
  activeOnly?: boolean
  limit?: number
}

export const userDirectoryApi = {
  list: async (q: UserDirectoryQuery = {}): Promise<DirectoryUser[]> => {
    const p = new URLSearchParams()
    if (q.search) p.set('search', q.search)
    if (q.roles?.length) p.set('roles', q.roles.join(','))
    if (q.ids?.length) p.set('ids', q.ids.join(','))
    if (q.activeOnly === false) p.set('activeOnly', 'false')
    if (q.limit) p.set('limit', String(q.limit))
    const qs = p.toString()
    const r = await api<{ items: DirectoryUser[] }>(`/api/user-directory${qs ? `?${qs}` : ''}`)
    return r.items
  },
}
